/**
 * Returns the page language, based on the HTML lang attribute
 */
 const pageLang = (() => {
    let html = document.querySelector('html')
    let lang = html.getAttribute('lang') || 'en'
    return lang.substr(0, 2).toLowerCase()
  })()
  
  export default pageLang
  


// WEBPACK FOOTER //
// ./scripts/util/pageLang.js